import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  "@global": {
    "*::-webkit-scrollbar": {
      width: "6px",
    },
    "*::-webkit-scrollbar-track": {
      "-webkit-box-shadow": " inset 0 0 5px rgb(54, 54, 54)",
      borderRadius: "10px",
    },
    "*::-webkit-scrollbar-thumb": {
      backgroundColor: theme.palette.secondary.main,
      borderRadius: "10px",
    },

    "*::-webkit-scrollbar-thumb:hover": {
      backgroundColor: theme.palette.secondary.main,
      width: "10px",
    },
  },
  root: {
    boxSizing: "border-box",
  },
  assetsPageModals: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  tableContainer: {
    marginTop: "5px",
    overflowX: "auto",
    overflowY: "auto",
    width: "100%",
  },
  assetsTableContainer: {
    marginTop: "5px",
    overflowX: "auto",
    overflowY: "auto",
    width: "100%",
  },
  tableCustomView: {
    width: "max-content !important",
    minWidth: "100%",
    tableLayout: "auto",
    "& .MuiTableCell-root": {
      width: "max-content",
      maxWidth: "250px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  },
  tableHeaderCustom: {
    backgroundColor: theme.palette.primary.main,
  },
  headTableCustom: {
    padding: "10px 5px!important",
    color: `${theme.palette.text.tertiary} !important`,
    backgroundColor: `${theme.palette.primary.main} !important`,
    zIndex: "3",
    width: "180px !important",
    borderBottom: `1px solid ${theme.palette.text.tertiary} !important`,
    fontSize: "14px !important"
  },
  table: {
    width: "100%",
  },
  tableHeader: {
    backgroundColor: theme.palette.primary.main,
    display: "table",
    width: "100%",
    tableLayout: "fixed",
  },
  tableBody: {
    display: "block",
    overflowY: "auto",
    [theme.breakpoints.down(823)]: {
      height: `calc(100vh - 305px)`,
    },
  },
  tableRow: {
    borderCollapse: "collapse",
  },
  headTable: {
    padding: "1.3% 0% !important",
    color: theme.palette.text.tertiary,
    borderBottom: `1px solid ${theme.palette.text.tertiary}`,
    width: "17.5%",
    background: theme.palette.primary.main,
  },
  headTableTwo: {
    padding: "1.3% 0% !important",
    color: theme.palette.text.tertiary,
    borderBottom: `1px solid ${theme.palette.text.tertiary}`,
    width: "15%",
    background: theme.palette.primary.main,
  },
}));

export default useStyles;
